import { render, staticRenderFns } from "./BudgetTotalsTab.vue?vue&type=template&id=be5b638c"
import script from "./BudgetTotalsTab.vue?vue&type=script&lang=ts"
export * from "./BudgetTotalsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports